import classNames from 'classnames';
import { useState } from 'react';
import { LuCheck } from 'react-icons/lu';
import styles from './Checkbox.module.css';

interface CheckboxProps {
  defaultChecked?: boolean;
  checked?: boolean;
  onChange?: (isChecked: boolean) => void;
}

const Checkbox = ({
  defaultChecked = false,
  checked = undefined,
  onChange = () => {},
}: CheckboxProps): JSX.Element => {
  const [isChecked, setIsChecked] = useState<boolean>(
    checked || defaultChecked,
  );
  return (
    <div
      className={styles.container}
      onClick={(event) => {
        event.stopPropagation();
        setIsChecked(!isChecked);
        if (onChange) {
          onChange(isChecked);
        }
      }}
    >
      <div className={styles.hover}></div>
      <div
        className={classNames(styles.checkbox, { [styles.checked]: isChecked })}
      >
        {isChecked && <LuCheck className={styles.checkMark} />}
      </div>
    </div>
  );
};

export default Checkbox;
